var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuckNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 391,
    viewBox: "0 0 541 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 270.5,
    cy: 370,
    rx: 270.5,
    ry: 21,
    fill: "#BFC5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.966 196.488C166.475 231.26 175.178 346.1 246.635 362.114C300.228 386.82 328.984 370.807 344.66 300.347C353.821 259.17 276.697 166.291 263.871 144.33C251.046 122.368 270.284 50.9938 268.91 24.9147C267.536 -1.16448 207.988 -23.1259 211.195 56.4842C214.401 136.094 199.456 161.716 182.966 196.488Z",
    fill: "#C0C5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.532 114.255C220.526 109.984 246.268 104.464 259.46 114.712C259.46 99.6138 265.415 60.4619 268.622 41.2457C271.828 22.0295 268.164 0.0680555 239.306 0.525585C210.448 0.983114 209.99 40.7881 211.823 64.1221C213.288 82.7893 210.754 106.934 209.532 114.255Z",
    fill: "#969FC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.797 54.2516C252.039 49.0121 217.165 50.9914 211.293 48.6761C204.657 60.2667 148.018 75.4151 182.676 87.6311C217.335 99.847 246.932 70.5495 250.797 54.2516Z",
    fill: "#6E79A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.578 153.852C245.437 152.991 253.581 152.13 272.442 169.776C309.305 208.943 323.022 246.388 327.737 282.542C332.452 318.696 303.379 344.944 289.234 348.388C275.089 351.831 251.987 346.577 220.983 319.563C199.455 300.805 199.143 243.806 202.143 204.639C205.144 165.472 225.719 154.712 235.578 153.852Z",
    fill: "#969FC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.436 278.879C180.261 274.21 162.198 266.584 153.457 250.607C145.372 214.505 183.702 190.481 195.672 200.174C212.416 217.071 219.524 235.173 221.253 248.538C222.981 261.903 215.559 277.733 204.436 278.879Z",
    fill: "#6E79A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M344.281 259.255C361.864 246.674 373.87 233.721 376.322 216.906C372.763 183.046 336.297 176.017 329.608 188.583C321.164 209.026 320.567 227.087 322.871 239.173C325.175 251.259 335.291 262.216 344.281 259.255Z",
    fill: "#6E79A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuckNotFound);
export default __webpack_public_path__ + "static/media/duckNotFound.f81b1846ca8e4d4ad95ad6e6dbd4fdcb.svg";
export { ForwardRef as ReactComponent };